<template>
  <div class="login">
    <div class="container">
      <div class="row">
      </div>
      <div class="login--card">

        <h2>Jelentkezz be</h2>

        <div class="login--card--form">
          <validation-observer v-slot="{ handleSubmit }" tag="div">
            <form @submit.prevent="handleSubmit(formSubmit)" class="form form--login">

              <div>
                <ValidationProvider rules="required" v-slot="{ failedRules }">

                  <div class="form-label">E-mail cím</div>
                  <input class="emailInput" placeholder="E-mail" v-model="loginForm.email"
                         name="E-mail" type="text"/>
                  <span class="error">{{
                      getErrorMessage("email", Object.entries(failedRules)[0])
                    }}</span>
                </ValidationProvider>

                <ValidationProvider rules="required" v-slot="{ failedRules }">
                  <div class="form-label margin-top-plus">Jelszó</div>
                  <input
                      v-model="loginForm.psw"
                      type="password"
                      placeholder="Jelszó"
                      class="form-control"
                      name="Jelszo"
                      id="psw"
                      ref="password"
                  />
                  <span class="error">{{
                      getErrorMessage("psw", Object.entries(failedRules)[0])
                    }}</span>
                </ValidationProvider>

                <div class="text-link-login">
                  <a class="text-link " href="/registration">Regisztrálj, ha még nem tetted meg!</a>
                </div>
              </div>

              <div class="error--s form__error" style="font-size:12px; color: red; margin-bottom: 10px;"
                   v-if="error.length > 0">
                {{ error }}
              </div>
              <button type="submit" class="btn btn-green btn-primary logInButton">Belépés</button>
            </form>
          </validation-observer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {required} from 'vee-validate/dist/rules';
import {setInteractionMode} from 'vee-validate';
import errorMessages from "@/assets/errorMessages.json";
import ApiHandler from "@/mixins/apiHandlerMI"
import viewMI from "@/mixins/viewMI";

setInteractionMode('eager');
extend('required', {
  ...required,
  message: "{_field_} is required."
});

export default {
  data() {
    return {
      loginForm: {
        email: undefined,
        psw: undefined
      },
      error: []
    }
  },
  mixins: [ApiHandler, viewMI],
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  created() {
  },
  methods: {
    // logout() {

    //   //delete local storage
    //   localStorage.removeItem('ebus_token')
    //   this.$store.state.token = null

    //   //go to login page
    //   this.$router.push({name: 'LogIn'})
    // },
    getErrorMessage(fieldName, violation) {
      return violation
          ? (errorMessages[fieldName] &&
          errorMessages[fieldName][violation[0]]) ??
          violation[1]
          : undefined;
    },
    formSubmit() {
      let _this = this

      _this.post('login',
          {
            email: _this.loginForm.email,
            password: _this.loginForm.psw
          },
          {}, function (response) {
            //success
            // //console.log(response.data)
            if (response.data.token != null || response.data.token != '' || response.data.token != undefined) {
              //console.log('sikeres belépés', response.data.user.user_type)
              localStorage.setItem('ebus_token', response.data.token)
              _this.$store.state.token = response.data.token                            
              _this.$store.dispatch('setUserData', response.data.user)              
            }

          }, function (error) {
            //error
            //console.log('login error:', error.data)

            if (error.data.error == 'Not found!') {
              _this.error = 'Rossz jelszó vagy e-mail cím'
            }
          }
      )
    }

  }
}
</script>